(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[691],{

/***/ 4545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p2p",
      function () {
        return __webpack_require__(79209);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ P2P; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(54675);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(18661);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ToggleButtonGroup/ToggleButtonGroup.js + 2 modules
var ToggleButtonGroup = __webpack_require__(85390);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ToggleButton/ToggleButton.js + 1 modules
var ToggleButton = __webpack_require__(87054);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(77169);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(22841);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Checkbox/Checkbox.js + 6 modules
var Checkbox = __webpack_require__(31362);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(55343);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(58316);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Select/Select.js + 4 modules
var Select = __webpack_require__(53442);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(10160);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Search.js
var Search = __webpack_require__(96506);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Add.js
var Add = __webpack_require__(72428);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Edit.js
var Edit = __webpack_require__(51797);
// EXTERNAL MODULE: ./components/Navbar/index.tsx + 1 modules
var Navbar = __webpack_require__(6784);
// EXTERNAL MODULE: ./models/account.ts
var models_account = __webpack_require__(88541);
// EXTERNAL MODULE: ./utils/useIsMobile.ts
var useIsMobile = __webpack_require__(23326);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./models/p2p.ts
/* provided dependency */ var Buffer = __webpack_require__(21876)["Buffer"];

const currencyToJson = (c)=>{
    try {
        const m = JSON.parse(c);
        return {
            method: m.method || "",
            currency: m.currency || "",
            contact: m.contact || ""
        };
    } catch (err) {
        return {
            method: "",
            contact: "",
            currency: c
        };
    }
};
const methodToJson = (c)=>{
    try {
        const m = JSON.parse(c);
        return {
            method: m.method,
            contact: m.contact
        };
    } catch (err) {
        return {
            method: c,
            contact: ""
        };
    }
};
// Get P2P Details (commission, expiry, etc)
const fetchP2PConfigs = async (secretjs)=>{
    const result = await secretjs.query.compute.queryContract({
        contract_address: "secret16a5fxlqxnw7pt9ajagzks4fqsv3dnjseqqyew4" || 0,
        code_hash: "7cedeb28a40a1c31ab68f692c94694ca9ce8b5fb8c2dd08c9f99ce978ccaf765" || 0,
        query: {
            config: {}
        }
    });
    const configs = [
        {
            ...result.config.config,
            contract_address: "secret16a5fxlqxnw7pt9ajagzks4fqsv3dnjseqqyew4" || 0,
            code_hash: "7cedeb28a40a1c31ab68f692c94694ca9ce8b5fb8c2dd08c9f99ce978ccaf765" || 0,
            deal_token: result.config.config.deal_token_a,
            name: "sSCRT",
            decimals: 6
        },
        {
            ...result.config.config,
            contract_address: "secret16a5fxlqxnw7pt9ajagzks4fqsv3dnjseqqyew4" || 0,
            code_hash: "7cedeb28a40a1c31ab68f692c94694ca9ce8b5fb8c2dd08c9f99ce978ccaf765" || 0,
            deal_token: result.config.config.deal_token_b,
            name: "sUSDC (Noble)",
            decimals: 6
        },
        {
            ...result.config.config,
            contract_address: "secret16a5fxlqxnw7pt9ajagzks4fqsv3dnjseqqyew4" || 0,
            code_hash: "7cedeb28a40a1c31ab68f692c94694ca9ce8b5fb8c2dd08c9f99ce978ccaf765" || 0,
            deal_token: result.config.config.deal_token_c,
            name: "SILK",
            decimals: 6
        }
    ];
    console.log({
        result
    });
    return configs;
};
// Get Token Balance
const fetchSnipTokenBalance = async (params, secretjs, disableSuggest)=>{
    try {
        var _window_keplr;
        const key = await ((_window_keplr = window.keplr) === null || _window_keplr === void 0 ? void 0 : _window_keplr.getSecret20ViewingKey(params.chain_id, params.contract_address));
        const result = await secretjs.query.compute.queryContract({
            contract_address: params.contract_address,
            code_hash: params.code_hash,
            query: {
                balance: {
                    key,
                    address: params.address
                }
            }
        });
        if (result.viewing_key_error) {
            throw new Error(result.viewing_key_error.msg);
        } else {
            return Number(lodash_default().get(result, "balance.amount", "0")) / 10 ** params.decimals;
        }
    } catch (err) {
        if (!disableSuggest && err.message === "There is no matched secret20") {
            var _window_keplr1;
            await ((_window_keplr1 = window.keplr) === null || _window_keplr1 === void 0 ? void 0 : _window_keplr1.suggestToken(params.chain_id, params.contract_address));
            return await fetchSnipTokenBalance(params, secretjs, true);
        } else {
            throw new Error(err.message);
        }
    }
};
// Get Posts and Deals
const fetchP2PPosts = async (params, secretjs)=>{
    var _dealsResult_active_deals, _postsResult_active_posts;
    const postsResult = await secretjs.query.compute.queryContract({
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        query: {
            active_posts: {}
        }
    });
    const dealsResult = await secretjs.query.compute.queryContract({
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        query: {
            active_deals: {}
        }
    });
    const dealsMap = lodash_default().groupBy((dealsResult === null || dealsResult === void 0 ? void 0 : (_dealsResult_active_deals = dealsResult.active_deals) === null || _dealsResult_active_deals === void 0 ? void 0 : _dealsResult_active_deals.deals) || [], "post_id");
    const posts = ((postsResult === null || postsResult === void 0 ? void 0 : (_postsResult_active_posts = postsResult.active_posts) === null || _postsResult_active_posts === void 0 ? void 0 : _postsResult_active_posts.posts) || []).map((p)=>({
            ...p,
            settle_currency: currencyToJson(p.settle_currency),
            deals: (dealsMap[p.post_id] || []).reverse().map((d)=>({
                    ...d,
                    settle_currency: currencyToJson(d.settle_currency)
                }))
        })).reverse();
    console.log({
        posts,
        dealsMap
    });
    return posts;
};
// Get My Payment Info
const fetchMyPaymentInfo = async (params, secretjs)=>{
    console.log({
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        query: {
            my_payment_info: {
                key: params.viewing_key,
                address: params.address
            }
        }
    });
    const result = await secretjs.query.compute.queryContract({
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        query: {
            my_payment_info: {
                key: params.viewing_key,
                address: params.address
            }
        }
    });
    if (typeof result === "string") {
        throw new Error(result);
    }
    const paymentInfo = {
        ...result,
        ...methodToJson(result.method)
    };
    console.log({
        paymentInfo
    });
    return paymentInfo;
};
// Get Deal Payment Info
const fetchDealPaymentInfo = async (params, secretjs)=>{
    var _result_deal_detail, _result_deal_detail1, _result_deal_detail_payment_info;
    const result = await secretjs.query.compute.queryContract({
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        query: {
            deal_detail: {
                deal_id: params.deal_id,
                key: params.viewing_key,
                address: params.address
            }
        }
    });
    if (typeof result === "string") {
        throw new Error(result);
    }
    const paymentInfo = {
        ...(result === null || result === void 0 ? void 0 : (_result_deal_detail = result.deal_detail) === null || _result_deal_detail === void 0 ? void 0 : _result_deal_detail.payment_info) || {},
        ...methodToJson((result === null || result === void 0 ? void 0 : (_result_deal_detail1 = result.deal_detail) === null || _result_deal_detail1 === void 0 ? void 0 : (_result_deal_detail_payment_info = _result_deal_detail1.payment_info) === null || _result_deal_detail_payment_info === void 0 ? void 0 : _result_deal_detail_payment_info.method) || "")
    };
    console.log({
        paymentInfo
    });
    return paymentInfo;
};
const setP2PViewingKey = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.query_auth.address,
        code_hash: params.query_auth.code_hash,
        msg: {
            set_viewing_key: {
                key: params.viewing_key
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Set Up Payment Information
const registerP2PPaymentInfo = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            register_payment_info: {
                method: params.method,
                detail: params.detail
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Create Post
const createP2PPost = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            add_post: {
                is_dealer_buy: params.is_dealer_buy,
                amount: params.amount,
                min_amount: params.min_amount,
                settle_currency: params.settle_currency,
                settle_price: params.settle_price,
                deal_token: params.deal_token
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Cancel Post
const cancelP2PPost = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            cancel_post: {
                post_id: params.post_id
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Create Deal
const enterP2PDeal = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            enter_deal: {
                post_id: params.post_id,
                amount: params.amount
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Dealer Deposit
const dealerDeposit = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.token_address,
        code_hash: params.token_code_hash,
        msg: {
            send: {
                recipient: params.contract_address,
                amount: params.amount,
                msg: Buffer.from(JSON.stringify({
                    dealer: {
                        post_id: params.post_id
                    }
                })).toString("base64")
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Customer Deposit
const customerDeposit = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.token_address,
        code_hash: params.token_code_hash,
        msg: {
            send: {
                recipient: params.contract_address,
                amount: params.amount,
                msg: Buffer.from(JSON.stringify({
                    customer: {
                        deal_id: params.deal_id
                    }
                })).toString("base64")
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Confirm Off-Chain Transfer
const confirmOffChainTransfer = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            confirm_bank_transfer: {
                deal_id: params.deal_id
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Cancel Deal
const cancelP2PDeal = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            cancel_deal: {
                deal_id: params.deal_id
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Resolve Deal
const resolveDeal = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            resolve_deal: {
                deal_id: params.deal_id
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};
// Dispute Deal
const disputeDeal = async (params, secretjs)=>{
    const tx = await secretjs.tx.compute.executeContract({
        sender: params.address,
        contract_address: params.contract_address,
        code_hash: params.code_hash,
        msg: {
            dispute_deal: {
                deal_id: params.deal_id
            }
        }
    }, {
        gasLimit: 400000,
        gasPriceInFeeDenom: 0.25
    });
    console.log(tx);
    if (tx.code !== 0) {
        throw new Error(tx.rawLog);
    }
    return tx;
};

// EXTERNAL MODULE: ./components/AlertModal/index.tsx + 4 modules
var AlertModal = __webpack_require__(94997);
// EXTERNAL MODULE: ./models/finaTokenInfo.ts
var finaTokenInfo = __webpack_require__(6248);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Badge/Badge.js + 6 modules
var Badge = __webpack_require__(64159);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(91359);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(21448);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(72389);
// EXTERNAL MODULE: ./utils/formatNumber.ts
var formatNumber = __webpack_require__(8978);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 16 modules
var format = __webpack_require__(58091);
;// CONCATENATED MODULE: ./components/P2P/PostCard.tsx






const StyledBadge = (0,styled/* default */.ZP)(Badge/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        "& .MuiBadge-badge": {
            right: -20
        }
    };
});
const PostCard = (param)=>{
    let { highlighted , post , config , onButtonClick , isMobile , buttonText , buttonBadge , buttonDisabledText , onAltButtonClick , altButtonText , altButtonDisabledText  } = param;
    var _ref;
    const { account  } = (0,models_account/* useAccount */.mA)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [altLoading, setAltLoading] = (0,react.useState)(false);
    const deal = ((post === null || post === void 0 ? void 0 : post.deals) || []).find((d)=>d.customer === account.address) || ((post === null || post === void 0 ? void 0 : post.dealer) === account.address ? ((post === null || post === void 0 ? void 0 : post.deals) || []).find((d)=>d.state === "dispute") : undefined);
    const expiry = 1000 * Number(((_ref = deal || post) === null || _ref === void 0 ? void 0 : _ref.expiry) || 0);
    return post ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        variant: "outlined",
        sx: (t)=>({
                bgcolor: t.palette.background.default,
                mb: 4,
                borderColor: highlighted ? t.palette.primary.main : undefined
            }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            sx: {
                position: "relative"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            gutterBottom: true,
                            sx: {
                                color: "text.secondary",
                                fontSize: 14
                            },
                            children: isMobile ? post.dealer.slice(0, 8) + "..." + post.dealer.slice(-8) : post.dealer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            gap: 2,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    gutterBottom: true,
                                    sx: {
                                        color: "text.secondary",
                                        fontSize: 14
                                    },
                                    children: [
                                        "Trade ID: ",
                                        post.post_id
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    sx: {
                                        textTransform: "capitalize"
                                    },
                                    size: "small",
                                    variant: "outlined",
                                    label: (deal || post).state.replace("_bank", "").replace(/_/g, " "),
                                    color: (deal || post).state === "dispute" ? "error" : "success"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "div",
                    mb: 2,
                    children: [
                        (0,formatNumber/* formatNumber */.u)(post.settle_price / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)),
                        " ",
                        post.settle_currency.currency,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body1",
                            component: "span",
                            children: [
                                " / ",
                                (config === null || config === void 0 ? void 0 : config.name) || ""
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    gutterBottom: true,
                    children: [
                        "Available Amount:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                (0,formatNumber/* formatNumber */.u)(post.amount / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)),
                                " ",
                                config === null || config === void 0 ? void 0 : config.name
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    gutterBottom: true,
                    children: [
                        "Minimum Amount:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                (0,formatNumber/* formatNumber */.u)(post.min_amount / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)),
                                " ",
                                config === null || config === void 0 ? void 0 : config.name
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    gutterBottom: true,
                    children: [
                        "Payment Method: ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: post.settle_currency.method
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    gutterBottom: true,
                    children: [
                        "Contact: ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: post.settle_currency.contact
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "body2",
                    gutterBottom: true,
                    children: [
                        "Expiry: ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: expiry ? (0,format/* default */.Z)(expiry, "yyyy-MM-dd, HH:mm") : "N/A"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    sx: {
                        height: isMobile ? 40 : 0
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    gap: 2,
                    sx: {
                        position: "absolute",
                        bottom: 16,
                        right: 16
                    },
                    children: [
                        onAltButtonClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                            title: altButtonDisabledText,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: altButtonDisabledText ? {
                                    cursor: "not-allowed"
                                } : undefined,
                                onClick: async ()=>{
                                    if (altButtonDisabledText) {
                                        return;
                                    }
                                    try {
                                        setAltLoading(true);
                                        const result = await onAltButtonClick();
                                        setAltLoading(false);
                                        return result;
                                    } catch (err) {
                                        setLoading(false);
                                        throw err;
                                    }
                                },
                                variant: "outlined",
                                disabled: altLoading,
                                children: altLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    sx: {
                                        mx: 1.5
                                    },
                                    size: 25
                                }) : altButtonText
                            })
                        }) : null,
                        onButtonClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                            title: buttonDisabledText,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: buttonDisabledText ? {
                                    cursor: "not-allowed"
                                } : undefined,
                                onClick: async ()=>{
                                    if (buttonDisabledText) {
                                        return;
                                    }
                                    try {
                                        setLoading(true);
                                        const result = await onButtonClick();
                                        setLoading(false);
                                        return result;
                                    } catch (err) {
                                        setLoading(false);
                                        throw err;
                                    }
                                },
                                disabled: loading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadge, {
                                    badgeContent: buttonBadge,
                                    color: "secondary",
                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        sx: {
                                            mx: 1.5
                                        },
                                        size: 25
                                    }) : buttonText || (!(post === null || post === void 0 ? void 0 : post.is_dealer_buy) ? "Buy" : "Sell")
                                })
                            })
                        }) : null
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var P2P_PostCard = (PostCard);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
;// CONCATENATED MODULE: ./utils/decodeTxMsg.ts
const decodeTxMsg = (tx)=>{
    try {
        const data = new TextDecoder().decode(tx.data[0]);
        const arr = data.split("{");
        arr.shift();
        const arr2 = ("{" + arr.join("{")).split("}");
        arr2.pop();
        const result = arr2.join("}") + "}";
        return JSON.parse(result);
    } catch (err) {
        return {};
    }
};
/* harmony default export */ var utils_decodeTxMsg = (decodeTxMsg);

;// CONCATENATED MODULE: ./components/P2P/EnterDealModal.tsx










const EnterDealModal = (param)=>{
    let { open , onClose , post , config , refetch  } = param;
    const secretjs = (0,models_account/* useSecretNetworkClient */.Sr)();
    const isMobile = (0,useIsMobile/* default */.Z)();
    const { account  } = (0,models_account/* useAccount */.mA)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)("");
    const [success, setSuccess] = (0,react.useState)("");
    const [amount, setAmount] = (0,react.useState)("");
    const [max, setMax] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (open && account.address && secretjs) {
            var _config_deal_token, _config_deal_token1;
            fetchSnipTokenBalance({
                contract_address: (config === null || config === void 0 ? void 0 : (_config_deal_token = config.deal_token) === null || _config_deal_token === void 0 ? void 0 : _config_deal_token.address) || "",
                code_hash: (config === null || config === void 0 ? void 0 : (_config_deal_token1 = config.deal_token) === null || _config_deal_token1 === void 0 ? void 0 : _config_deal_token1.code_hash) || "",
                address: account.address,
                chain_id: account.chainId,
                decimals: (config === null || config === void 0 ? void 0 : config.decimals) || 6
            }, secretjs).then(setMax);
        }
    }, [
        open,
        config,
        account
    ]);
    const message = amount && Number(amount) > ((post === null || post === void 0 ? void 0 : post.amount) || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6) ? "Exceed max amount" : amount && Number(amount) < ((post === null || post === void 0 ? void 0 : post.min_amount) || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6) ? "Less than minimum amount" : "";
    (0,react.useEffect)(()=>{
        if (refetch && (success || error)) {
            refetch();
        }
    }, [
        refetch,
        success,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: open,
                onClose: onClose,
                maxWidth: "sm",
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        if (!secretjs) {
                            return;
                        }
                        try {
                            setError("");
                            setLoading(true);
                            const paramsAmount = (Number(amount) * 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)).toFixed();
                            const tx = await enterP2PDeal({
                                contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                address: account.address,
                                post_id: (post === null || post === void 0 ? void 0 : post.post_id) || "",
                                amount: paramsAmount
                            }, secretjs);
                            if (post === null || post === void 0 ? void 0 : post.is_dealer_buy) {
                                var _config_deal_token, _config_deal_token1, _txMsg_deal_stage_process;
                                const txMsg = utils_decodeTxMsg(tx);
                                await customerDeposit({
                                    contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                    token_address: (config === null || config === void 0 ? void 0 : (_config_deal_token = config.deal_token) === null || _config_deal_token === void 0 ? void 0 : _config_deal_token.address) || "",
                                    token_code_hash: (config === null || config === void 0 ? void 0 : (_config_deal_token1 = config.deal_token) === null || _config_deal_token1 === void 0 ? void 0 : _config_deal_token1.code_hash) || "",
                                    address: (account === null || account === void 0 ? void 0 : account.address) || "",
                                    deal_id: (txMsg === null || txMsg === void 0 ? void 0 : (_txMsg_deal_stage_process = txMsg.deal_stage_process) === null || _txMsg_deal_stage_process === void 0 ? void 0 : _txMsg_deal_stage_process.deal_id) || "",
                                    amount: paramsAmount
                                }, secretjs);
                            }
                            setLoading(false);
                            setSuccess("You have successfully entered a trade.");
                            onClose();
                        } catch (err) {
                            setLoading(false);
                            setError(err.message);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
                            children: [
                                !(post === null || post === void 0 ? void 0 : post.is_dealer_buy) ? "Buy" : "Sell",
                                " ",
                                config === null || config === void 0 ? void 0 : config.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_PostCard, {
                                    config: config,
                                    post: post,
                                    isMobile: isMobile
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: "Amount"
                                        }),
                                        (post === null || post === void 0 ? void 0 : post.is_dealer_buy) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                underline: "hover",
                                                sx: {
                                                    cursor: "pointer",
                                                    ml: 1
                                                },
                                                onClick: ()=>setAmount(String(max)),
                                                children: [
                                                    "Available: ",
                                                    (0,formatNumber/* formatNumber */.u)(max || 0),
                                                    " ",
                                                    config === null || config === void 0 ? void 0 : config.name
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: amount,
                                    error: !!error && error !== "empty",
                                    onChange: (e)=>{
                                        if (!e.target.value.match(/[^.0-9]/) && (e.target.value.match(/\./g) || []).length < 2) {
                                            setAmount(e.target.value);
                                        }
                                    },
                                    placeholder: "0.0",
                                    fullWidth: true,
                                    InputProps: {
                                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "end",
                                            children: config === null || config === void 0 ? void 0 : config.name
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "flex-end",
                                    my: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body1",
                                        children: [
                                            !(post === null || post === void 0 ? void 0 : post.is_dealer_buy) ? "You spend" : "You receive",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: (0,formatNumber/* formatNumber */.u)(Number(amount) * (((post === null || post === void 0 ? void 0 : post.settle_price) || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)))
                                            }),
                                            " ",
                                            post === null || post === void 0 ? void 0 : post.settle_currency.currency,
                                            " for",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: (0,formatNumber/* formatNumber */.u)(Number(amount))
                                            }),
                                            " ",
                                            config === null || config === void 0 ? void 0 : config.name
                                        ]
                                    })
                                }),
                                message ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: (theme)=>theme.palette.error.main,
                                    children: message
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    sx: {
                                        mr: 1
                                    },
                                    variant: "text",
                                    size: "large",
                                    onClick: onClose,
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    disabled: loading || !!message || !amount,
                                    size: "large",
                                    type: "submit",
                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        sx: {
                                            mx: 1.5
                                        },
                                        size: 25
                                    }) : "Confirm"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!success,
                onClose: ()=>setSuccess(""),
                title: "Success",
                description: success,
                type: "success"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!error,
                onClose: ()=>setError(""),
                title: "Error",
                description: error,
                type: "error"
            })
        ]
    });
};
/* harmony default export */ var P2P_EnterDealModal = (EnterDealModal);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Autocomplete/Autocomplete.js + 4 modules
var Autocomplete = __webpack_require__(44383);
;// CONCATENATED MODULE: ./components/P2P/RegisterP2PModal.tsx






const paymentOptions = [
    "Ethereum Transfer",
    "Wire Transfer",
    "Paypal",
    "Other"
];
const RegisterP2PModal = (param)=>{
    let { open , onClose , config , paymentInfo , refetch  } = param;
    const secretjs = (0,models_account/* useSecretNetworkClient */.Sr)();
    const { account  } = (0,models_account/* useAccount */.mA)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)("");
    const [success, setSuccess] = (0,react.useState)("");
    const [paymentMethod, setPaymentMethod] = (0,react.useState)("");
    const [paymentDetail, setPaymentDetail] = (0,react.useState)("");
    const [contactInfo, setContactInfo] = (0,react.useState)("");
    const [paymentMethodSelect, setPaymentMethodSelect] = (0,react.useState)(paymentOptions[0]);
    (0,react.useEffect)(()=>{
        setPaymentMethod((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "");
        setPaymentMethodSelect(paymentOptions.includes((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "") ? (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "Other" : "Other");
        setPaymentDetail((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.detail) || "");
        setContactInfo((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.contact) || "");
    }, [
        paymentInfo
    ]);
    (0,react.useEffect)(()=>{
        if (refetch && (success || error)) {
            refetch();
        }
    }, [
        refetch,
        success,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: open,
                onClose: onClose,
                maxWidth: "sm",
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        if (!secretjs) {
                            return;
                        }
                        try {
                            setError("");
                            setLoading(true);
                            await registerP2PPaymentInfo({
                                contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                address: account.address,
                                method: JSON.stringify({
                                    method: paymentMethodSelect === "Other" ? paymentMethod : paymentMethodSelect,
                                    contact: contactInfo
                                }),
                                detail: paymentDetail
                            }, secretjs);
                            setLoading(false);
                            setSuccess("You have successfully updated your payment info.");
                            onClose();
                        } catch (err) {
                            setLoading(false);
                            setError(err.message);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                            children: "Register Payment Info"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Contact"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: contactInfo,
                                    onChange: (e)=>{
                                        setContactInfo(e.target.value);
                                    },
                                    placeholder: "eg. TG: @finacash",
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Payment Method"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                    options: paymentOptions,
                                    autoHighlight: true,
                                    disableClearable: true,
                                    componentsProps: {
                                        popper: {
                                            sx: {
                                                left: 0
                                            }
                                        }
                                    },
                                    filterOptions: (x)=>x,
                                    renderInput: (params)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                            ...params,
                                            inputProps: {
                                                ...params.inputProps,
                                                autoComplete: "new-password"
                                            }
                                        }),
                                    value: paymentMethodSelect,
                                    onChange: (e, v)=>setPaymentMethodSelect(v)
                                }),
                                paymentMethodSelect === "Other" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    sx: {
                                        mt: 2
                                    },
                                    value: paymentMethod,
                                    onChange: (e)=>{
                                        setPaymentMethod(e.target.value);
                                    },
                                    placeholder: "Please specify",
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Payment Information (Encrypted)"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: paymentDetail,
                                    onChange: (e)=>{
                                        setPaymentDetail(e.target.value);
                                    },
                                    placeholder: "eg. 0x123123...",
                                    fullWidth: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    sx: {
                                        mr: 1
                                    },
                                    variant: "text",
                                    size: "large",
                                    onClick: onClose,
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    disabled: loading || !paymentMethodSelect || paymentMethodSelect === "Other" && !paymentMethod || !paymentDetail || !contactInfo,
                                    size: "large",
                                    type: "submit",
                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        sx: {
                                            mx: 1.5
                                        },
                                        size: 25
                                    }) : "Confirm"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!success,
                onClose: ()=>setSuccess(""),
                title: "Success",
                description: success,
                type: "success"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!error,
                onClose: ()=>setError(""),
                title: "Error",
                description: error,
                type: "error"
            })
        ]
    });
};
/* harmony default export */ var P2P_RegisterP2PModal = (RegisterP2PModal);

;// CONCATENATED MODULE: ./components/P2P/CreateP2PPostModal.tsx









const CreateP2PPostModal = (param)=>{
    let { open , onClose , onEditPaymentInfo , config , paymentInfo , refetch  } = param;
    const secretjs = (0,models_account/* useSecretNetworkClient */.Sr)();
    const { account  } = (0,models_account/* useAccount */.mA)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)("");
    const [success, setSuccess] = (0,react.useState)("");
    const [amount, setAmount] = (0,react.useState)("");
    const [minAmount, setMinAmount] = (0,react.useState)("");
    const [price, setPrice] = (0,react.useState)("");
    const [currency, setCurrency] = (0,react.useState)("");
    const [contactInfo, setContactInfo] = (0,react.useState)((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.contact) || "");
    const [paymentMethodSelect, setPaymentMethodSelect] = (0,react.useState)(paymentOptions.includes((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "") ? (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "Other" : "Other");
    const [paymentMethod, setPaymentMethod] = (0,react.useState)((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "");
    const [paymentDetail, setPaymentDetail] = (0,react.useState)((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.detail) || "");
    const [isBuy, setIsBuy] = (0,react.useState)(true);
    const [max, setMax] = (0,react.useState)(0);
    const insufficientBalance = !isBuy && amount && Number(amount) > max;
    (0,react.useEffect)(()=>{
        setPaymentMethod((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "");
        setPaymentMethodSelect(paymentOptions.includes((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "") ? (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || "Other" : "Other");
        setPaymentDetail((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.detail) || "");
        setContactInfo((paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.contact) || "");
    }, [
        paymentInfo
    ]);
    (0,react.useEffect)(()=>{
        if (open && account.address && secretjs) {
            var _config_deal_token, _config_deal_token1;
            fetchSnipTokenBalance({
                contract_address: (config === null || config === void 0 ? void 0 : (_config_deal_token = config.deal_token) === null || _config_deal_token === void 0 ? void 0 : _config_deal_token.address) || "",
                code_hash: (config === null || config === void 0 ? void 0 : (_config_deal_token1 = config.deal_token) === null || _config_deal_token1 === void 0 ? void 0 : _config_deal_token1.code_hash) || "",
                address: account.address,
                chain_id: account.chainId,
                decimals: (config === null || config === void 0 ? void 0 : config.decimals) || 6
            }, secretjs).then(setMax);
        }
    }, [
        open,
        config,
        account
    ]);
    (0,react.useEffect)(()=>{
        if (refetch && (success || error)) {
            refetch();
        }
    }, [
        refetch,
        success,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: open,
                onClose: onClose,
                maxWidth: "xs",
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: async (e)=>{
                        e.preventDefault();
                        if (!secretjs) {
                            return;
                        }
                        try {
                            var _config_deal_token, _config_deal_token1;
                            setError("");
                            setLoading(true);
                            const paramsAmount = (Number(amount) * 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)).toFixed();
                            const newPaymentInfo = {
                                method: paymentMethodSelect === "Other" ? paymentMethod : paymentMethodSelect,
                                contact: contactInfo,
                                detail: paymentDetail
                            };
                            if (newPaymentInfo.method !== (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || newPaymentInfo.contact !== (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.contact) || newPaymentInfo.detail !== (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.detail)) {
                                await registerP2PPaymentInfo({
                                    contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                    code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                    address: account.address,
                                    method: JSON.stringify({
                                        method: newPaymentInfo.method,
                                        contact: newPaymentInfo.contact
                                    }),
                                    detail: newPaymentInfo.detail
                                }, secretjs);
                            }
                            const tx = await createP2PPost({
                                contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                deal_token: {
                                    address: (config === null || config === void 0 ? void 0 : (_config_deal_token = config.deal_token) === null || _config_deal_token === void 0 ? void 0 : _config_deal_token.address) || "",
                                    code_hash: (config === null || config === void 0 ? void 0 : (_config_deal_token1 = config.deal_token) === null || _config_deal_token1 === void 0 ? void 0 : _config_deal_token1.code_hash) || ""
                                },
                                address: account.address,
                                is_dealer_buy: isBuy,
                                amount: paramsAmount,
                                min_amount: (Number(minAmount) * 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)).toFixed(),
                                settle_currency: JSON.stringify({
                                    method: newPaymentInfo.method,
                                    currency: currency,
                                    contact: newPaymentInfo.contact
                                }),
                                settle_price: (Number(price) * 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)).toFixed()
                            }, secretjs);
                            if (!isBuy) {
                                var _config_deal_token2, _config_deal_token3, _txMsg_add_post;
                                const txMsg = utils_decodeTxMsg(tx);
                                await dealerDeposit({
                                    contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                    token_address: (config === null || config === void 0 ? void 0 : (_config_deal_token2 = config.deal_token) === null || _config_deal_token2 === void 0 ? void 0 : _config_deal_token2.address) || "",
                                    token_code_hash: (config === null || config === void 0 ? void 0 : (_config_deal_token3 = config.deal_token) === null || _config_deal_token3 === void 0 ? void 0 : _config_deal_token3.code_hash) || "",
                                    address: (account === null || account === void 0 ? void 0 : account.address) || "",
                                    post_id: (txMsg === null || txMsg === void 0 ? void 0 : (_txMsg_add_post = txMsg.add_post) === null || _txMsg_add_post === void 0 ? void 0 : _txMsg_add_post.post_id) || "",
                                    amount: paramsAmount
                                }, secretjs);
                            }
                            setLoading(false);
                            setSuccess("You have successfully created a post");
                            onClose();
                        } catch (err) {
                            setLoading(false);
                            setError(err.message);
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                            children: "Create P2P Post"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: [
                                            "Buy/Sell ",
                                            config === null || config === void 0 ? void 0 : config.name
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleButtonGroup/* default */.Z, {
                                    color: "primary",
                                    value: isBuy,
                                    exclusive: true,
                                    onChange: (e, v)=>v !== null && setIsBuy(v),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                                            sx: {
                                                width: 100
                                            },
                                            value: true,
                                            children: "Buy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                                            sx: {
                                                width: 100
                                            },
                                            value: false,
                                            children: "Sell"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: "Amount"
                                        }),
                                        !isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                                underline: "hover",
                                                sx: {
                                                    cursor: "pointer",
                                                    ml: 1
                                                },
                                                onClick: ()=>setAmount(String(max)),
                                                children: [
                                                    "Available: ",
                                                    (0,formatNumber/* formatNumber */.u)(max || 0),
                                                    " ",
                                                    config === null || config === void 0 ? void 0 : config.name
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: amount,
                                    error: insufficientBalance || !!error && error !== "empty",
                                    onChange: (e)=>{
                                        if (!e.target.value.match(/[^.0-9]/) && (e.target.value.match(/\./g) || []).length < 2) {
                                            setAmount(e.target.value);
                                        }
                                    },
                                    placeholder: "0.0",
                                    fullWidth: true,
                                    InputProps: {
                                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "end",
                                            children: config === null || config === void 0 ? void 0 : config.name
                                        })
                                    }
                                }),
                                insufficientBalance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    color: "error",
                                    children: "Amount exceeds available balance"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Minimum Trade Amount"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: minAmount,
                                    error: !!error && error !== "empty",
                                    onChange: (e)=>{
                                        if (!e.target.value.match(/[^.0-9]/) && (e.target.value.match(/\./g) || []).length < 2) {
                                            setMinAmount(e.target.value);
                                        }
                                    },
                                    placeholder: "0.0",
                                    fullWidth: true,
                                    InputProps: {
                                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "end",
                                            children: config === null || config === void 0 ? void 0 : config.name
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Trade Currency"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: currency,
                                    error: !!error && error !== "empty",
                                    onChange: (e)=>{
                                        setCurrency(e.target.value);
                                    },
                                    placeholder: "eg. USDT, USDC, BTC...",
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: [
                                            "Price ",
                                            currency ? "(".concat(currency, "/").concat(config === null || config === void 0 ? void 0 : config.name, ")") : ""
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: price,
                                    error: !!error && error !== "empty",
                                    onChange: (e)=>{
                                        if (!e.target.value.match(/[^.0-9]/) && (e.target.value.match(/\./g) || []).length < 2) {
                                            setPrice(e.target.value);
                                        }
                                    },
                                    placeholder: "0.0",
                                    fullWidth: true,
                                    InputProps: {
                                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "end",
                                            children: currency
                                        })
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Contact"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: contactInfo,
                                    onChange: (e)=>{
                                        setContactInfo(e.target.value);
                                    },
                                    placeholder: "eg. TG: @finacash",
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Payment Method"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
                                    options: [
                                        "Ethereum Transfer",
                                        "Wire Transfer",
                                        "Paypal",
                                        "Other"
                                    ],
                                    autoHighlight: true,
                                    disableClearable: true,
                                    componentsProps: {
                                        popper: {
                                            sx: {
                                                left: 0
                                            }
                                        }
                                    },
                                    filterOptions: (x)=>x,
                                    renderInput: (params)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                            ...params,
                                            inputProps: {
                                                ...params.inputProps,
                                                autoComplete: "new-password"
                                            }
                                        }),
                                    value: paymentMethodSelect,
                                    onChange: (e, v)=>setPaymentMethodSelect(v)
                                }),
                                paymentMethodSelect === "Other" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    sx: {
                                        mt: 2
                                    },
                                    value: paymentMethod,
                                    onChange: (e)=>{
                                        setPaymentMethod(e.target.value);
                                    },
                                    placeholder: "Please specify",
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    mt: 2,
                                    mb: 1,
                                    direction: "row",
                                    justifyContent: "space-between",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Payment Information (Encrypted)"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    value: paymentDetail,
                                    onChange: (e)=>{
                                        setPaymentDetail(e.target.value);
                                    },
                                    placeholder: "eg. 0x123123...",
                                    fullWidth: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    sx: {
                                        mr: 1
                                    },
                                    variant: "text",
                                    size: "large",
                                    onClick: onClose,
                                    children: "Close"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    disabled: loading || !amount || !minAmount || !price || !currency || !isBuy && Number(amount) > max,
                                    size: "large",
                                    type: "submit",
                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        sx: {
                                            mx: 1.5
                                        },
                                        size: 25
                                    }) : "Confirm"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!success,
                onClose: ()=>setSuccess(""),
                title: "Success",
                description: success,
                type: "success"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!error,
                onClose: ()=>setError(""),
                title: "Error",
                description: error,
                type: "error"
            })
        ]
    });
};
/* harmony default export */ var P2P_CreateP2PPostModal = (CreateP2PPostModal);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(86777);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Table/Table.js + 1 modules
var Table = __webpack_require__(90244);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(93978);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableCell/TableCell.js + 1 modules
var TableCell = __webpack_require__(5605);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(39807);
;// CONCATENATED MODULE: ./components/P2P/BankTransferModal.tsx









const BankTransferModal = (param)=>{
    let { open , onClose , deal , config , refetch  } = param;
    var _deal_settle_currency;
    const secretjs = (0,models_account/* useSecretNetworkClient */.Sr)();
    const { finaToken  } = (0,finaTokenInfo/* useFinaTokenInfo */.Px)();
    const isMobile = (0,useIsMobile/* default */.Z)();
    const { account  } = (0,models_account/* useAccount */.mA)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [error, setError] = (0,react.useState)("");
    const [success, setSuccess] = (0,react.useState)("");
    const [paymentInfo, setPaymentInfo] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        if (open && secretjs && config && deal) {
            fetchDealPaymentInfo({
                contract_address: config.contract_address,
                code_hash: config.code_hash,
                address: account.address,
                viewing_key: finaToken.viewingKey,
                deal_id: deal.deal_id
            }, secretjs).then(setPaymentInfo);
        }
    }, [
        open,
        deal,
        account.address,
        config,
        finaToken.viewingKey,
        secretjs
    ]);
    (0,react.useEffect)(()=>{
        if (refetch && (success || error)) {
            refetch();
        }
    }, [
        refetch,
        success,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                open: open,
                onClose: onClose,
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                        children: "Payment Detail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                my: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Payment Method"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        children: (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) || ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                my: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Payment Detail"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        children: paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.detail
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                my: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Amount"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "h6",
                                        children: [
                                            (0,formatNumber/* formatNumber */.u)(((deal === null || deal === void 0 ? void 0 : deal.settle_price) || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6) * ((deal === null || deal === void 0 ? void 0 : deal.amount) || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)),
                                            " ",
                                            deal === null || deal === void 0 ? void 0 : (_deal_settle_currency = deal.settle_currency) === null || _deal_settle_currency === void 0 ? void 0 : _deal_settle_currency.currency
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "flex-end",
                                my: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "Trader Contact"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        children: paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.contact
                                    })
                                ]
                            }),
                            ((deal === null || deal === void 0 ? void 0 : deal.state) || "").includes("bank_transfer") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        gutterBottom: true,
                                        children: [
                                            "Please click ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Confirm Payment"
                                            }),
                                            " after making payment with the information above"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "* Make sure to contact the trader before making payment."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: "* Make sure to keep all chat records related to the trade in case of dispute."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    mr: 1
                                },
                                variant: "text",
                                size: "large",
                                onClick: onClose,
                                children: "Close"
                            }),
                            ((deal === null || deal === void 0 ? void 0 : deal.state) || "").includes("bank_transfer") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                disabled: loading,
                                size: "large",
                                onClick: async ()=>{
                                    try {
                                        setLoading(true);
                                        await confirmOffChainTransfer({
                                            contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                            code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                            address: account.address,
                                            deal_id: (deal === null || deal === void 0 ? void 0 : deal.deal_id) || ""
                                        }, secretjs);
                                        setLoading(false);
                                        setSuccess("You have successfully confirmed your payment!");
                                        onClose();
                                    } catch (err) {
                                        setLoading(false);
                                        setError(err.message);
                                    }
                                },
                                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                    sx: {
                                        mx: 1.5
                                    },
                                    size: 25
                                }) : "Confirm Payment"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!success,
                onClose: ()=>setSuccess(""),
                title: "Success",
                description: success,
                type: "success"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!error,
                onClose: ()=>setError(""),
                title: "Error",
                description: error,
                type: "error"
            })
        ]
    });
};
/* harmony default export */ var P2P_BankTransferModal = (BankTransferModal);

;// CONCATENATED MODULE: ./components/P2P/MyDealsModal.tsx










const MyDealsModal = (param)=>{
    let { open , onClose , post , config , refetch , ...props } = param;
    var _post_deals;
    const secretjs = (0,models_account/* useSecretNetworkClient */.Sr)();
    const { account  } = (0,models_account/* useAccount */.mA)();
    const isMobile = (0,useIsMobile/* default */.Z)();
    const [error, setError] = (0,react.useState)("");
    const [success, setSuccess] = (0,react.useState)("");
    const [transferModalDeal, setTransferModalDeal] = (0,react.useState)();
    const [loading, setLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (refetch && (success || error)) {
            refetch();
        }
    }, [
        refetch,
        success,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
                open: open,
                onClose: onClose,
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                        children: "My Deals"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_PostCard, {
                                config: config,
                                post: post,
                                isMobile: isMobile,
                                ...props
                            }),
                            (post === null || post === void 0 ? void 0 : post.dealer) === account.address && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: "ID"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: "Trader"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        align: "right",
                                                        children: "Amount"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        children: "State"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        align: "right"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                                            children: ((post === null || post === void 0 ? void 0 : post.deals) || []).map((deal)=>{
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                            children: deal.deal_id
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                                            children: [
                                                                deal.customer.slice(0, 8),
                                                                "...",
                                                                deal.customer.slice(-8)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                                            align: "right",
                                                            children: [
                                                                (0,formatNumber/* formatNumber */.u)(deal.amount / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)),
                                                                " ",
                                                                (config === null || config === void 0 ? void 0 : config.name) || ""
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                            sx: (theme)=>({
                                                                    textTransform: "capitalize",
                                                                    color: deal.state === "dispute" ? theme.palette.error.main : theme.palette.text.primary
                                                                }),
                                                            children: deal.state.replace("_bank", "").replace(/_/g, " ")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                                            align: "right",
                                                            children: [
                                                                (deal.state === "pend_customer_deposit" || deal.state === "pend_customer_transfer") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    size: "small",
                                                                    variant: "outlined",
                                                                    disabled: loading,
                                                                    onClick: async ()=>{
                                                                        try {
                                                                            setLoading(true);
                                                                            await cancelP2PDeal({
                                                                                contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                                                                code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                                                                address: account.address,
                                                                                deal_id: (deal === null || deal === void 0 ? void 0 : deal.deal_id) || ""
                                                                            }, secretjs);
                                                                            setSuccess("You have successfully canceled your trade!");
                                                                            setLoading(false);
                                                                            onClose();
                                                                        } catch (err) {
                                                                            setLoading(false);
                                                                            setError(err.message);
                                                                        }
                                                                    },
                                                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                                        sx: {
                                                                            mx: 1.5
                                                                        },
                                                                        size: 25
                                                                    }) : "Cancel"
                                                                }),
                                                                (deal.state === "pend_dealer_bank_transfer" || deal.state === "pend_customer_sign_off") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    sx: {
                                                                        ml: 2
                                                                    },
                                                                    size: "small",
                                                                    variant: "contained",
                                                                    disabled: loading,
                                                                    onClick: ()=>{
                                                                        setTransferModalDeal(deal);
                                                                    },
                                                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                                        sx: {
                                                                            mx: 1.5
                                                                        },
                                                                        size: 25
                                                                    }) : "Payment Detail"
                                                                }),
                                                                deal.state === "pend_dealer_sign_off" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                            sx: {
                                                                                ml: 2
                                                                            },
                                                                            size: "small",
                                                                            variant: "contained",
                                                                            disabled: loading,
                                                                            onClick: async ()=>{
                                                                                try {
                                                                                    setLoading(true);
                                                                                    await disputeDeal({
                                                                                        contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                                                                        code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                                                                        address: account.address,
                                                                                        deal_id: (deal === null || deal === void 0 ? void 0 : deal.deal_id) || ""
                                                                                    }, secretjs);
                                                                                    setSuccess('You have raised a dispute to the trade. Please create a ticket <a href="https://discord.com/channels/952397096722505768/1322233983391498324" target="_blank">here</a> to contact moderator.');
                                                                                    setLoading(false);
                                                                                    onClose();
                                                                                } catch (err) {
                                                                                    setError(err.message);
                                                                                    setLoading(false);
                                                                                }
                                                                            },
                                                                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                                                sx: {
                                                                                    mx: 1.5
                                                                                },
                                                                                size: 25
                                                                            }) : "Dispute"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                            sx: {
                                                                                ml: 2
                                                                            },
                                                                            size: "small",
                                                                            variant: "contained",
                                                                            disabled: loading,
                                                                            onClick: async ()=>{
                                                                                try {
                                                                                    setLoading(true);
                                                                                    await resolveDeal({
                                                                                        contract_address: (config === null || config === void 0 ? void 0 : config.contract_address) || "",
                                                                                        code_hash: (config === null || config === void 0 ? void 0 : config.code_hash) || "",
                                                                                        address: account.address,
                                                                                        deal_id: (deal === null || deal === void 0 ? void 0 : deal.deal_id) || ""
                                                                                    }, secretjs);
                                                                                    setLoading(false);
                                                                                    setSuccess("You have successfully signed off the trade!");
                                                                                    onClose();
                                                                                } catch (err) {
                                                                                    setLoading(false);
                                                                                    setError(err.message);
                                                                                }
                                                                            },
                                                                            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                                                sx: {
                                                                                    mx: 1.5
                                                                                },
                                                                                size: 25
                                                                            }) : "Sign Off"
                                                                        })
                                                                    ]
                                                                }),
                                                                deal.state === "dispute" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                    href: "https://discord.com/channels/952397096722505768/1322233983391498324",
                                                                    target: "_blank",
                                                                    children: "Create Ticket"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, deal.deal_id);
                                            })
                                        })
                                    ]
                                })
                            }),
                            !(post === null || post === void 0 ? void 0 : (_post_deals = post.deals) === null || _post_deals === void 0 ? void 0 : _post_deals.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                mt: 4,
                                variant: "h5",
                                align: "center",
                                color: "textSecondary",
                                children: "No Open Trades"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            sx: {
                                mr: 1
                            },
                            variant: "text",
                            size: "large",
                            onClick: onClose,
                            children: "Close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!success,
                onClose: ()=>setSuccess(""),
                title: "Success",
                html: success,
                type: "success"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                open: !!error,
                onClose: ()=>setError(""),
                title: "Error",
                description: error,
                type: "error"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_BankTransferModal, {
                open: !!transferModalDeal,
                onClose: ()=>setTransferModalDeal(undefined),
                deal: transferModalDeal,
                config: config,
                refetch: refetch
            })
        ]
    });
};
/* harmony default export */ var P2P_MyDealsModal = (MyDealsModal);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./utils/getP2PNotifications.ts

const getP2PNotifications = (configs, posts, address)=>{
    const myPosts = posts.filter((p)=>p.dealer === address || !!p.deals.find((d)=>d.customer === address));
    const notifications = [];
    myPosts.forEach((p)=>{
        const config = configs.find((c)=>c.deal_token.address === p.deal_token.address);
        if (p.dealer === address) {
            if (p.state === "pend_dealer_deposit") {
                return notifications.push({
                    post: p,
                    message: "Please deposit ".concat((0,formatNumber/* formatNumber */.u)(p.amount / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)), " ").concat(config === null || config === void 0 ? void 0 : config.name, " to your post")
                });
            }
            p.deals.forEach((d)=>{
                if (d.state === "pend_dealer_bank_transfer") {
                    return notifications.push({
                        post: p,
                        deal: d,
                        message: "Trader has deposited ".concat((0,formatNumber/* formatNumber */.u)(d.amount / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)), " ").concat(config === null || config === void 0 ? void 0 : config.name)
                    });
                } else if (d.state === "pend_dealer_sign_off") {
                    return notifications.push({
                        post: p,
                        deal: d,
                        message: "Trader has transfered ".concat((0,formatNumber/* formatNumber */.u)((d.settle_price || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6) * (d.amount || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)), " ").concat(p.settle_currency.currency, " to you")
                    });
                } else if (d.state === "dispute") {
                    return notifications.push({
                        post: p,
                        deal: d,
                        message: "Your deal (ID: ".concat(d.deal_id, ") is in dispute. Please reach out to moderator to resolve it as soon as possible.")
                    });
                }
            });
        } else {
            const d = p.deals.find((d)=>d.customer === address);
            if ((d === null || d === void 0 ? void 0 : d.state) === "pend_customer_deposit") {
                return notifications.push({
                    post: p,
                    deal: d,
                    message: "Please deposit ".concat((0,formatNumber/* formatNumber */.u)(d.amount / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)), " ").concat(config === null || config === void 0 ? void 0 : config.name, " to your deal")
                });
            } else if ((d === null || d === void 0 ? void 0 : d.state) === "pend_customer_bank_transfer") {
                return notifications.push({
                    post: p,
                    deal: d,
                    message: "Dealer has deposited ".concat((0,formatNumber/* formatNumber */.u)(d.amount / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)), " ").concat(config === null || config === void 0 ? void 0 : config.name)
                });
            } else if ((d === null || d === void 0 ? void 0 : d.state) === "pend_customer_sign_off") {
                return notifications.push({
                    post: p,
                    deal: d,
                    message: "Dealer has transfered ".concat((0,formatNumber/* formatNumber */.u)((d.settle_price || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6) * (d.amount || 0) / 10 ** ((config === null || config === void 0 ? void 0 : config.decimals) || 6)), " ").concat(p.settle_currency.currency, " to you")
                });
            } else if ((d === null || d === void 0 ? void 0 : d.state) === "dispute") {
                return notifications.push({
                    post: p,
                    deal: d,
                    message: "Your deal (ID: ".concat(d.deal_id, ") is in dispute. Please reach out to moderator to resolve it as soon as possible.")
                });
            }
        }
    });
    return notifications;
};
/* harmony default export */ var utils_getP2PNotifications = (getP2PNotifications);

;// CONCATENATED MODULE: ./pages/p2p.tsx



















function P2P() {
    var _currentP2PConfig_deal_token;
    const isMobile = (0,useIsMobile/* default */.Z)();
    const { account , connect  } = (0,models_account/* useAccount */.mA)();
    const { finaToken , getFinaToken  } = (0,finaTokenInfo/* useFinaTokenInfo */.Px)();
    const secretjs = (0,models_account/* useSecretNetworkClient */.Sr)();
    const [openCreatePostModal, setOpenCreatePostModal] = (0,react.useState)(false);
    const [openRegisterModal, setOpenRegisterModal] = (0,react.useState)(false);
    const [p2pConfigs, setP2PConfigs] = (0,react.useState)([]);
    const [currentP2PConfig, setCurrentP2PConfig] = (0,react.useState)();
    const [paymentInfo, setPaymentInfo] = (0,react.useState)();
    const [isBuy, setIsBuy] = (0,react.useState)(true);
    const [posts, setPosts] = (0,react.useState)([]);
    const [dealingPost, setDealingPost] = (0,react.useState)();
    const [myDealsPost, setMyDealsPost] = (0,react.useState)();
    const [paymentDetailDeal, setPaymentDetailDeal] = (0,react.useState)();
    const [keyNotSet, setKeyNotSet] = (0,react.useState)(false);
    const [keyLoading, setKeyLoading] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const [success, setSuccess] = (0,react.useState)("");
    const [error, setError] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        secretjs && fetchP2PConfigs(secretjs).then((result)=>{
            setP2PConfigs(result);
            setCurrentP2PConfig(result[0]);
        });
    }, [
        secretjs
    ]);
    const refetch = (0,react.useCallback)(()=>{
        if (account.address && secretjs && currentP2PConfig) {
            if (finaToken.viewingKey) {
                setKeyNotSet(false);
                fetchP2PPosts({
                    contract_address: currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address,
                    code_hash: currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash
                }, secretjs).then((ps)=>{
                    setPosts(ps);
                    setMyDealsPost((mdp)=>{
                        return ps.find((p)=>{
                            return p.post_id === (mdp === null || mdp === void 0 ? void 0 : mdp.post_id);
                        });
                    });
                });
                fetchMyPaymentInfo({
                    contract_address: currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address,
                    code_hash: currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash,
                    address: account.address,
                    viewing_key: finaToken.viewingKey
                }, secretjs).then(setPaymentInfo).catch((err)=>{
                    console.log(err);
                    if (err.message === "Generic error: Viewing key not match") {
                        setKeyNotSet(true);
                    } else if (err.message === "Generic error: No payment info is found") {
                        setOpenRegisterModal(true);
                    }
                });
            } else {
                setKeyNotSet(true);
            }
        }
    }, [
        currentP2PConfig,
        secretjs,
        account,
        finaToken.viewingKey
    ]);
    (0,react.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    (0,react.useEffect)(()=>{
        if (success || error) {
            refetch();
        }
    }, [
        success,
        error,
        refetch
    ]);
    const allPosts = posts.filter((p)=>{
        var _currentP2PConfig_deal_token;
        return (isBuy ? !p.is_dealer_buy : p.is_dealer_buy) && p.deal_token.address === (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : (_currentP2PConfig_deal_token = currentP2PConfig.deal_token) === null || _currentP2PConfig_deal_token === void 0 ? void 0 : _currentP2PConfig_deal_token.address) && [
            p.settle_currency.contact,
            p.settle_currency.currency,
            p.settle_currency.method,
            p.post_id,
            p.dealer
        ].map((a)=>a.toLowerCase().includes(search.toLowerCase())).includes(true) && (p.state === "open" || p.dealer === account.address || !!p.deals.find((d)=>d.customer === account.address));
    });
    const sortOptions = [
        "Date: New to Old",
        "Date: Old to New",
        "Price: Low to High",
        "Price: High to Low"
    ];
    const [sortBy, setSortBy] = (0,react.useState)(sortOptions[0]);
    const myPosts = allPosts.filter((p)=>p.dealer === account.address || !!p.deals.find((d)=>d.customer === account.address)).sort((a, b)=>{
        if (sortBy === "Date: New to Old") {
            return Number(b.post_id) - Number(a.post_id);
        } else if (sortBy === "Date: Old to New") {
            return Number(a.post_id) - Number(b.post_id);
        } else if (sortBy === "Price: Low to High") {
            return Number(a.settle_price) - Number(b.settle_price);
        } else if (sortBy === "Price: High to Low") {
            return Number(b.settle_price) - Number(a.settle_price);
        }
        return 0;
    });
    const openPosts = allPosts.filter((p)=>{
        var _currentP2PConfig_deal_token, _p_deal_token;
        return (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : (_currentP2PConfig_deal_token = currentP2PConfig.deal_token) === null || _currentP2PConfig_deal_token === void 0 ? void 0 : _currentP2PConfig_deal_token.address) === ((_p_deal_token = p.deal_token) === null || _p_deal_token === void 0 ? void 0 : _p_deal_token.address) && p.dealer !== account.address && !p.deals.find((d)=>d.customer === account.address);
    }).sort((a, b)=>{
        if (sortBy === "Date: New to Old") {
            return Number(b.post_id) - Number(a.post_id);
        } else if (sortBy === "Date: Old to New") {
            return Number(a.post_id) - Number(b.post_id);
        } else if (sortBy === "Price: Low to High") {
            return Number(a.settle_price) - Number(b.settle_price);
        } else if (sortBy === "Price: High to Low") {
            return Number(b.settle_price) - Number(a.settle_price);
        }
        return 0;
    });
    const notifications = utils_getP2PNotifications(p2pConfigs, posts, account.address);
    const myBuyPosts = notifications.filter((n)=>{
        var _currentP2PConfig_deal_token;
        return !n.post.is_dealer_buy && n.post.deal_token.address === (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : (_currentP2PConfig_deal_token = currentP2PConfig.deal_token) === null || _currentP2PConfig_deal_token === void 0 ? void 0 : _currentP2PConfig_deal_token.address) && (n.post.dealer === account.address || !!n.post.deals.find((d)=>d.customer === account.address));
    });
    const mySellPosts = notifications.filter((n)=>{
        var _currentP2PConfig_deal_token;
        return n.post.is_dealer_buy && n.post.deal_token.address === (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : (_currentP2PConfig_deal_token = currentP2PConfig.deal_token) === null || _currentP2PConfig_deal_token === void 0 ? void 0 : _currentP2PConfig_deal_token.address) && (n.post.dealer === account.address || !!n.post.deals.find((d)=>d.customer === account.address));
    });
    const postCardActions = (p)=>{
        if (p.dealer === account.address && p.state === "pend_dealer_deposit") {
            var _p_deals;
            return {
                buttonText: "Deposit ".concat((0,formatNumber/* formatNumber */.u)(p.amount / 10 ** ((currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.decimals) || 6)), " ").concat(currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.name),
                onButtonClick: async ()=>{
                    try {
                        await dealerDeposit({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            address: account.address,
                            token_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.deal_token.address) || "",
                            token_code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.deal_token.code_hash) || "",
                            amount: String(p.amount),
                            post_id: p.post_id
                        }, secretjs);
                        setSuccess("You have successfully deposited ".concat((0,formatNumber/* formatNumber */.u)(p.amount / 10 ** ((currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.decimals) || 6)), " ").concat(currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.name, " to your trade!"));
                    } catch (err) {
                        setError(err.message);
                    }
                },
                buttonDisabledText: "",
                altButtonText: "Cancel",
                onAltButtonClick: ((_p_deals = p.deals) === null || _p_deals === void 0 ? void 0 : _p_deals.length) ? undefined : async ()=>{
                    try {
                        await cancelP2PPost({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            post_id: p.post_id
                        }, secretjs);
                        setSuccess("You have successfully canceled your post!");
                    } catch (err) {
                        setError(err.message);
                    }
                },
                altButtonDisabledText: ""
            };
        } else if (!!p.deals.find((d)=>d.customer === account.address && d.state === "pend_customer_deposit")) {
            const deal = p.deals.find((d)=>d.customer === account.address && d.state === "pend_customer_deposit");
            return {
                buttonText: "Deposit ".concat((0,formatNumber/* formatNumber */.u)(((deal === null || deal === void 0 ? void 0 : deal.amount) || 0) / 10 ** ((currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.decimals) || 6)), " ").concat(currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.name),
                onButtonClick: async ()=>{
                    try {
                        const deal = p.deals.find((d)=>d.customer === account.address && d.state === "pend_customer_deposit");
                        await customerDeposit({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            address: account.address,
                            token_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.deal_token.address) || "",
                            token_code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.deal_token.code_hash) || "",
                            amount: String(deal === null || deal === void 0 ? void 0 : deal.amount),
                            deal_id: (deal === null || deal === void 0 ? void 0 : deal.deal_id) || ""
                        }, secretjs);
                        setSuccess("You have successfully deposited ".concat((0,formatNumber/* formatNumber */.u)(((deal === null || deal === void 0 ? void 0 : deal.amount) || 0) / 10 ** ((currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.decimals) || 6)), " ").concat(currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.name, " to your trade!"));
                    } catch (err) {
                        setError(err.message);
                    }
                },
                buttonDisabledText: "",
                altButtonText: "Cancel",
                altButtonDisabledText: Number((deal === null || deal === void 0 ? void 0 : deal.expiry) || 0) * 1000 > Date.now() ? "You can cancel the trade after it expires" : "",
                onAltButtonClick: async ()=>{
                    try {
                        await cancelP2PDeal({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            deal_id: (deal === null || deal === void 0 ? void 0 : deal.deal_id) || ""
                        }, secretjs);
                        setSuccess("You have successfully canceled your trade!");
                    } catch (err) {
                        setError(err.message);
                    }
                }
            };
        } else if (!!p.deals.find((d)=>d.customer === account.address && d.state === "pend_dealer_bank_transfer")) {
            const deal1 = p.deals.find((d)=>d.customer === account.address && d.state === "pend_dealer_bank_transfer");
            return {
                altButtonText: "Cancel",
                onAltButtonClick: async ()=>{
                    try {
                        await cancelP2PDeal({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            deal_id: (deal1 === null || deal1 === void 0 ? void 0 : deal1.deal_id) || ""
                        }, secretjs);
                        setSuccess("You have successfully canceled your trade!");
                    } catch (err) {
                        setError(err.message);
                    }
                },
                altButtonDisabledText: Number((deal1 === null || deal1 === void 0 ? void 0 : deal1.expiry) || 0) * 1000 > Date.now() ? "You can cancel the trade after it expires" : ""
            };
        } else if (!!p.deals.find((d)=>d.customer === account.address && d.state === "pend_customer_bank_transfer")) {
            const deal2 = p.deals.find((d)=>d.customer === account.address && d.state === "pend_customer_bank_transfer");
            return {
                onButtonClick: ()=>setPaymentDetailDeal(deal2),
                buttonText: "Payment Details",
                altButtonText: "Cancel",
                onAltButtonClick: async ()=>{
                    try {
                        await cancelP2PDeal({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            deal_id: (deal2 === null || deal2 === void 0 ? void 0 : deal2.deal_id) || ""
                        }, secretjs);
                        setSuccess("You have successfully canceled your trade!");
                    } catch (err) {
                        setError(err.message);
                    }
                },
                altButtonDisabledText: Number((deal2 === null || deal2 === void 0 ? void 0 : deal2.expiry) || 0) * 1000 > Date.now() ? "You can cancel the trade after it expires" : ""
            };
        } else if (!!p.deals.find((d)=>d.customer === account.address && d.state === "pend_dealer_sign_off")) {
            const deal3 = p.deals.find((d)=>d.customer === account.address && d.state === "pend_dealer_sign_off");
            return {
                buttonText: "Resolve",
                onButtonClick: async ()=>{
                    try {
                        await resolveDeal({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            deal_id: (deal3 === null || deal3 === void 0 ? void 0 : deal3.deal_id) || ""
                        }, secretjs);
                        setSuccess("You have successfully resolved your deal!");
                    } catch (err) {
                        setError(err.message);
                    }
                },
                buttonDisabledText: Number((deal3 === null || deal3 === void 0 ? void 0 : deal3.expiry) || 0) * 1000 > Date.now() ? "You can resolve the trade after it expires" : ""
            };
        } else if (p.dealer === account.address && p.state === "open") {
            var _p_deals1, _p_deals2;
            return {
                onButtonClick: ()=>setMyDealsPost(p),
                buttonText: "My Deals (".concat((_p_deals1 = p.deals) === null || _p_deals1 === void 0 ? void 0 : _p_deals1.length, ")"),
                buttonBadge: notifications.filter((n)=>n.post.post_id === p.post_id).length,
                altButtonText: "Cancel",
                onAltButtonClick: ((_p_deals2 = p.deals) === null || _p_deals2 === void 0 ? void 0 : _p_deals2.length) ? undefined : async ()=>{
                    try {
                        await cancelP2PPost({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            post_id: p.post_id
                        }, secretjs);
                        setSuccess("You have successfully canceled your post!");
                    } catch (err) {
                        setError(err.message);
                    }
                }
            };
        } else if (!!p.deals.find((d)=>d.customer === account.address && d.state === "pend_customer_sign_off")) {
            const deal4 = p.deals.find((d)=>d.customer === account.address && d.state === "pend_customer_sign_off");
            return {
                onButtonClick: async ()=>{
                    try {
                        await resolveDeal({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            deal_id: deal4 === null || deal4 === void 0 ? void 0 : deal4.deal_id
                        }, secretjs);
                        setSuccess("You have successfully signed off the trade!");
                    } catch (err) {
                        setError(err.message);
                    }
                },
                buttonText: "Sign Off",
                altButtonText: "Dispute",
                onAltButtonClick: async ()=>{
                    try {
                        await disputeDeal({
                            contract_address: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.contract_address) || "",
                            code_hash: (currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.code_hash) || "",
                            address: account.address,
                            deal_id: deal4 === null || deal4 === void 0 ? void 0 : deal4.deal_id
                        }, secretjs);
                        setSuccess('You have raised a dispute to the trade. Please create a ticket <a href="https://discord.com/channels/952397096722505768/1322233983391498324" target="_blank">here</a> to contact moderator.');
                    } catch (err) {
                        setError(err.message);
                    }
                }
            };
        } else if (!!p.deals.find((d)=>d.customer === account.address && d.state === "dispute")) {
            return {
                altButtonText: "Create Ticket",
                onAltButtonClick: ()=>window.open("https://discord.com/channels/952397096722505768/1322233983391498324", "_blank")
            };
        } else {
            return {};
        }
    };
    const [myTradesOnly, setMyTradesOnly] = (0,react.useState)(false);
    return secretjs ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                bgcolor: (theme)=>theme.palette.background.default,
                minHeight: "100vh",
                pb: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                        activeTab: "/p2p",
                        notifications: notifications,
                        onNotificationClick: (n)=>{
                            setMyDealsPost(n.post);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        sx: {
                            mt: {
                                md: 8,
                                xs: 4
                            },
                            mb: 8
                        },
                        maxWidth: "md",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                mb: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                                        value: currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : (_currentP2PConfig_deal_token = currentP2PConfig.deal_token) === null || _currentP2PConfig_deal_token === void 0 ? void 0 : _currentP2PConfig_deal_token.address,
                                        onChange: (e, v)=>{
                                            console.log({
                                                p2pConfigs,
                                                v,
                                                e
                                            });
                                            setCurrentP2PConfig(p2pConfigs.find((p)=>{
                                                var _p_deal_token;
                                                return ((_p_deal_token = p.deal_token) === null || _p_deal_token === void 0 ? void 0 : _p_deal_token.address) === v;
                                            }));
                                        },
                                        children: p2pConfigs.map((p)=>{
                                            var _p_deal_token, _p_deal_token1;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                label: p.name,
                                                value: (_p_deal_token = p.deal_token) === null || _p_deal_token === void 0 ? void 0 : _p_deal_token.address
                                            }, (_p_deal_token1 = p.deal_token) === null || _p_deal_token1 === void 0 ? void 0 : _p_deal_token1.address);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleButtonGroup/* default */.Z, {
                                        color: "primary",
                                        value: isBuy,
                                        exclusive: true,
                                        onChange: (e, v)=>v !== null && setIsBuy(v),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                                                sx: {
                                                    width: 100
                                                },
                                                value: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadge, {
                                                    badgeContent: myBuyPosts.length,
                                                    color: "secondary",
                                                    children: "Buy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton/* default */.Z, {
                                                sx: {
                                                    width: 100
                                                },
                                                value: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadge, {
                                                    badgeContent: mySellPosts.length,
                                                    color: "secondary",
                                                    children: "Sell"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                sx: {
                                    mb: 2
                                },
                                value: search,
                                onChange: (e)=>{
                                    setSearch(e.target.value);
                                },
                                placeholder: "Search by Payment Method, Currency, Trade ID or Trader Address",
                                fullWidth: true,
                                InputProps: {
                                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                my: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            checked: myTradesOnly,
                                            onChange: (e, c)=>setMyTradesOnly(c)
                                        }),
                                        label: "Show My Trades Only"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                children: "Sort By"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                label: "Sort By",
                                                value: sortBy,
                                                onChange: (e)=>setSortBy(e.target.value),
                                                size: "small",
                                                children: sortOptions.map((o)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                        value: o,
                                                        children: o
                                                    }, o))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            myPosts.map((p)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_PostCard, {
                                    highlighted: true,
                                    post: p,
                                    config: currentP2PConfig,
                                    isMobile: isMobile,
                                    ...postCardActions(p)
                                }, p.post_id)),
                            !(openPosts.length + myPosts.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                mb: 4,
                                children: "No Open Trades"
                            }),
                            !myTradesOnly && openPosts.map((p)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(P2P_PostCard, {
                                    post: p,
                                    config: currentP2PConfig,
                                    isMobile: isMobile,
                                    onButtonClick: ()=>{
                                        if (!(paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method)) {
                                            setOpenRegisterModal(true);
                                        } else {
                                            setDealingPost(p);
                                        }
                                    }
                                }, p.post_id);
                            })
                        ]
                    })
                ]
            }),
            (paymentInfo === null || paymentInfo === void 0 ? void 0 : paymentInfo.method) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fab/* default */.Z, {
                variant: "extended",
                color: "primary",
                sx: {
                    position: "fixed",
                    right: 40,
                    bottom: 100
                },
                onClick: ()=>{
                    setOpenCreatePostModal(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                        sx: {
                            mr: 1
                        }
                    }),
                    "Create Post"
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Fab/* default */.Z, {
                variant: "extended",
                color: "secondary",
                sx: {
                    position: "fixed",
                    right: 40,
                    bottom: 40
                },
                disabled: keyLoading,
                onClick: async ()=>{
                    try {
                        if (!!(currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.query_auth) && secretjs) {
                            if (keyNotSet) {
                                setKeyLoading(true);
                                let newKey;
                                if (!finaToken.viewingKey) {
                                    newKey = await getFinaToken(true);
                                }
                                await setP2PViewingKey({
                                    address: account.address,
                                    viewing_key: (newKey === null || newKey === void 0 ? void 0 : newKey.viewingKey) || finaToken.viewingKey,
                                    query_auth: currentP2PConfig === null || currentP2PConfig === void 0 ? void 0 : currentP2PConfig.query_auth
                                }, secretjs);
                                refetch();
                                setKeyLoading(false);
                            } else {
                                setOpenRegisterModal(true);
                            }
                        }
                    } catch (err) {
                        setKeyLoading(false);
                        setError(err.message);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit/* default */.Z, {
                        sx: {
                            mr: 1
                        }
                    }),
                    keyNotSet ? keyLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        sx: {
                            mx: 1.5
                        },
                        size: 25
                    }) : "Set Viewing Key" : "Payment Info"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_CreateP2PPostModal, {
                open: openCreatePostModal,
                onClose: ()=>setOpenCreatePostModal(false),
                config: currentP2PConfig,
                paymentInfo: paymentInfo,
                onEditPaymentInfo: ()=>{
                    setOpenCreatePostModal(false);
                    setOpenRegisterModal(true);
                },
                refetch: refetch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_RegisterP2PModal, {
                open: openRegisterModal,
                onClose: ()=>setOpenRegisterModal(false),
                config: currentP2PConfig,
                paymentInfo: paymentInfo,
                refetch: refetch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_EnterDealModal, {
                open: !!dealingPost,
                onClose: ()=>setDealingPost(undefined),
                post: dealingPost,
                config: currentP2PConfig,
                refetch: refetch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_MyDealsModal, {
                open: !!myDealsPost,
                onClose: ()=>setMyDealsPost(undefined),
                post: myDealsPost,
                config: currentP2PConfig,
                refetch: refetch,
                ...myDealsPost && (myDealsPost === null || myDealsPost === void 0 ? void 0 : myDealsPost.dealer) !== account.address ? postCardActions(myDealsPost) : {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P2P_BankTransferModal, {
                open: !!paymentDetailDeal,
                onClose: ()=>setPaymentDetailDeal(undefined),
                deal: paymentDetailDeal,
                config: currentP2PConfig,
                refetch: refetch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
                type: success ? "success" : "error",
                title: success ? "Success" : "Error",
                html: success || error,
                open: !!(success || error),
                onClose: ()=>{
                    setSuccess("");
                    setError("");
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        bgcolor: (theme)=>theme.palette.background.default,
        minHeight: "100vh",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                activeTab: "/p2p"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                style: {
                    position: "absolute",
                    left: 0,
                    top: 60,
                    width: "30vw"
                },
                alt: "p2p",
                src: "/p2p/left.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                style: {
                    position: "absolute",
                    right: 0,
                    top: 60,
                    width: "30vw"
                },
                alt: "p2p",
                src: "/p2p/right.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    px: 4,
                    zIndex: 10000
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        maxWidth: 600,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                mb: 2,
                                variant: "h2",
                                className: "gradient",
                                align: "center",
                                children: "Fina P2P"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                align: "center",
                                variant: "body2",
                                mb: 4,
                                children: [
                                    "Thank you for using Fina P2P! Please follow the instructions",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://docs.fina.cash/fina-p2p/features/getting-started",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "here"
                                    }),
                                    " ",
                                    "to access Fina P2P on Secret Network:"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "large",
                        onClick: connect,
                        startIcon: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "Fina",
                            src: __webpack_require__(18449),
                            width: 20,
                            height: 20,
                            style: {
                                borderRadius: 4
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "Keplr",
                            src: __webpack_require__(94956),
                            width: 20,
                            height: 20,
                            style: {
                                borderRadius: 4
                            }
                        }),
                        children: "Connect Wallet"
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,167,438,864,556,774,888,179], function() { return __webpack_exec__(4545); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);